import { ActionCreator, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'store';
import kubernetesService from 'services/api/customer/kubernetes-service';
import { Cluster } from 'components/Kubernetes/types/cluster';
import { ActionTypes } from './types/state.types';

export const setListOfClusters: ActionCreator<AnyAction> = (payload: Cluster[]) => ({
  type: ActionTypes.SET_LIST,
  payload,
});

export type ThunkClusterDispatch = ThunkDispatch<RootState, void, AnyAction>;

export const fetchClusterList = () => async (dispatch: ThunkClusterDispatch) => {
  const { data } = await kubernetesService.getClusters();
  const clusters = data.data;
  dispatch(setListOfClusters(clusters));
  return clusters;
};
